import { z } from "zod";
import { KycSchema, RelationshipSchema, UserSchema } from "../treezor/index.js";

export default {
  params: z.object({
    accountId: z.string(),
    specifiedUSPerson: z.boolean(),
    firstname: UserSchema.shape.firstname,
    lastname: UserSchema.shape.lastname,
    middleNames: UserSchema.shape.middleNames,
    birthday: z.union([z.iso.date(), z.literal("")]),
    placeOfBirth: UserSchema.shape.placeOfBirth,
    birthCountry: UserSchema.shape.birthCountry,
    nationality: UserSchema.shape.nationality,
    phone: UserSchema.shape.phone,
    address1: UserSchema.shape.address1,
    address2: UserSchema.shape.address2,
    address3: UserSchema.shape.address3.unwrap(),
    postcode: UserSchema.shape.postcode,
    city: UserSchema.shape.city,
    country: UserSchema.shape.country,
    legalRole: z.enum(["legalRepresentative", "companyRepresentative"]),
    isEffectiveBeneficiary: z.boolean(),
  }),
  response: z.object({
    user: UserSchema.extend({ kyc: KycSchema.optional() }),
    relationship: RelationshipSchema.nullable(),
    isLegalRepresentative: z.boolean(),
    isEffectiveBeneficiary: z.boolean(),
  }),
};
